import { StripeCardExpiryElement, StripeElements } from '@stripe/stripe-js';
import React, { useEffect } from 'react';

interface CardExpiryProps {
  disabled?: boolean;
  elements: StripeElements;
  cardExpiry?: string;
  onInit?: (cardNumber: StripeCardExpiryElement) => void;
}

export function CardExpiry(props: CardExpiryProps) {
  const cardExpiryRef: React.RefObject<HTMLDivElement> = React.createRef();

  useEffect(() => {
    const cardExpiryElement = props.elements!.create('cardExpiry', {
      placeholder: ''
    });
    cardExpiryElement!.mount('#cardExpiry');

    cardExpiryElement.on('focus', () => {
      cardExpiryRef!.current?.classList.remove('border-mint-medical-grey-light');
      cardExpiryRef!.current?.classList.add(
        'border-mint-medical-green',
        'outline-2',
        'outline-mint-medical-green-lighter'
      );
    });

    cardExpiryElement.on('blur', () => {
      cardExpiryRef!.current?.classList.add('border-mint-medical-grey-light');
      cardExpiryRef!.current?.classList.remove(
        'border-mint-medical-green',
        'outline-2',
        'outline-mint-medical-green-lighter'
      );
    });

    props.onInit && props.onInit(cardExpiryElement);

    return () => {
      cardExpiryElement.destroy();
    };
  }, [props]);

  return (
    <>
      <div
        className={
          !props.disabled
            ? 'h-12 w-full rounded-md border-2 border-mint-medical-grey-light p-3 text-base text-black outline-none placeholder:text-black focus:border-mint-medical-green focus:outline-2 focus:outline-mint-medical-green-lighter'
            : 'hidden'
        }
        ref={cardExpiryRef}
        id="cardExpiry"></div>

      <input
        disabled={true}
        value={props.cardExpiry}
        className={
          props.disabled
            ? 'h-12 w-full rounded-md border-2 border-mint-medical-grey-light bg-[#F0F0F0] p-3 text-base text-black outline-none placeholder:text-black'
            : 'hidden'
        }></input>
    </>
  );
}
